export default class {
    Id = null;

    TradePointId = null;

    Position = null;

    Fio = null;

    Phone = null;

    Birthday = null;

    Comment = null;

    Email = null;

    Skype = null;

    SocialNetworks = null;

    mapFromDto(dto) {
        if(!dto)
            return this;

        this.Id = dto.Id;
        this.TradePointId = dto.TradePointId;
        this.Position = dto.Position;
        this.Fio = dto.Fio;
        this.Phone = dto.Phone;
        this.Birthday = dto.Birthday;
        this.Comment = dto.Comment;
        this.Email = dto.Email;
        this.Skype = dto.Skype;
        this.SocialNetworks = dto.SocialNetworks;

        return this;
    }

    getBirthdayToDisplay() {
        let birthday = new Date(this.Birthday);
        return `${birthday.getDate()}.${birthday.getMonth()+1}.${birthday.getFullYear()} ${birthday.getHours()}:${birthday.getMinutes()}:${birthday.getSeconds()}`;

    }
}